<div class="layout-container" role="application">
  <lib-header (toggleMenu)="toggleSidebar()">
    <ng-content select="[header-content]"></ng-content>
  </lib-header>

  <div class="layout-body">
    <!-- Mobile sidebar backdrop -->
    @if (!isSidebarCollapsed) {
      <div
        class="sidebar-backdrop visible"
        role="presentation"
        aria-hidden="true"
        (click)="toggleSidebar()"
      ></div>
    }

    <lib-sidebar
      [menuItems]="menuItems"
      [isCollapsed]="isSidebarCollapsed"
    ></lib-sidebar>

    <main class="main-content" [class.sidebar-collapsed]="isSidebarCollapsed" role="main">
      <ng-content></ng-content>
    </main>
  </div>

  <!-- Toast Container -->
  <lib-toast-container />

  <!-- Confirm Dialog Container -->
  <lib-confirm-dialog-container />
</div>

